/* global window, FB, document */

export function loadFbSdk(appId, version) {
  return new Promise(resolve => {
    window.fbAsyncInit = function () { // eslint-disable-line func-names
      FB.init({
        appId,
        xfbml: false,
        version,
        cookie: true
      });
      FB.AppEvents.logPageView();
      resolve('SDK Loaded!');
    };
    (function (d, s, id) { // eslint-disable-line func-names
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      const js = d.createElement(s); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  });
}

export function getFbLoginStatus() {
  return new Promise(resolve => {
    window.FB.getLoginStatus(responseStatus => {
      resolve(responseStatus);
    });
  });
}

export function fbLogin(options) {
  return new Promise(resolve => {
    window.FB.login(response => resolve(response), options);
  });
}
export function fbLogout() {
  return new Promise(resolve => {
    window.FB.logout(response => resolve(response));
  });
}


export function setHomeScript(){
  const el =  document.createElement("script" )
       el.type = "application/ld+json"
       el.textContent = `{
  "@context": "https://www.schema.org/",
  "@type": "LocalBusiness",
  "name": "iGeek Repair Center - iPhone Repair / Phone Repair / Warren / Detroit",
  "url": "https://igeekrepaircenter.com/",
  "logo": "https://igeekrepaircenter.com/upload/header_logo/_1617674517.png",
  "image": "https://igeekrepaircenter.com/upload/section_image/_1612787760.png",
  "founders": [
 {
 "@type": "Person",
 "name": "Justin Dabish",
 "gender": "Male",
 "jobTitle": "Founder"
 } ],
  "description": "iGeek Repair Center is an electronic repair chain in the Detroit metro. With over a decade of expert service and multiple convenient locations, we bring top-notch tech repair to Detroit and Warren with our Mobile Repair Units.",
  "telephone": "+1 313-707-0777",
  "sameAs": [
  "https://www.instagram.com/igeekrepaircenter/"],
  "hasMap": "https://maps.app.goo.gl/mcDF9Bj44b5Fo5Jh7",
  "openingHoursSpecification": [
    {
     "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
       "Monday",
       "Tuesday",
       "Wednesday",
       "Thursday",
       "Friday",
       "Saturday" 
     ],
     "opens": "10:00",
     "closes": "19:00"
   }],
  "priceRange": "$$$",
  "address": {
	"@type": "PostalAddress",
	"streetAddress": "20503 Dequindre St",
	"addressLocality": "Detroit",
	"addressRegion": "MI",
	"postalCode": "48234",
	"addressCountry": "USA"
		},
  "location": {
	"@type": "Place",
	"geo": {
	"@type": "GeoCoordinates",
		"latitude": "42.44649",
		"longitude": "-83.08368"
			}
		},
  "areaServed": [{
	"@type": "City",
	"name": ["Detroit", "Warren"]
		}],
"department": [
	{
	"@type": "LocalBusiness",
	"name": "iGeek Repair Center - iPhone Repair / Phone Repair / Pontiac - Waterford",
	"description": "iGeek Repair Center is an electronic repair chain in the Detroit metro. With over a decade of expert service and multiple convenient locations, we bring top-notch tech repair to Pontiac and Waterford with our Mobile Repair Units.",
        "url": "https://igeekrepaircenter.com/#/store-location-details/3",
	"image": "https://igeekrepaircenter.com/upload/section_image/_1612787760.png",
	"telephone": "+1 248-499-9780",
        "hasMap": "https://maps.app.goo.gl/3kJ3hhSkDifE7AAz9",
        "openingHoursSpecification": [
          {
           "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
             "Monday",
             "Tuesday",
             "Wednesday",
             "Thursday",
             "Friday",
             "Saturday"
           ],
           "opens": "10:00",
           "closes": "19:00"
         }],
        "priceRange": "$$$",
	"address": {
		"@type": "PostalAddress",
		"streetAddress": "445 Elizabeth Lake Rd",
		"addressLocality": "Pontiac",
		"addressRegion": "MI",
		"postalCode": "48341",
		"addressCountry": "USA"
		},
	"location": {
		"@type": "Place",
		"geo": {
			"@type": "GeoCoordinates",
			"latitude": "42.63974",
			"longitude": "-83.32537"
			}
		},
	"areaServed": [{
		"@type": "City",
		"name": ["Pontiac", "Waterford"]			
		}]
  },
  {
	"@type": "LocalBusiness",
	"name": "iGeek Repair Center - iPhone Repair / Phone Repair / Eastpointe",
	"description": "iGeek Repair Center is an electronic repair chain in the Detroit metro. With over a decade of expert service and multiple convenient locations, we bring top-notch tech repair to Eastpointe with our Mobile Repair Units.",
	"url": "https://igeekrepaircenter.com/#/store-location-details/5",
        "image": "https://igeekrepaircenter.com/upload/section_image/_1612787760.png",
	"telephone": "+1 586-333-4005",
        "hasMap": "https://maps.app.goo.gl/zvmeCKWHhVELFLRL6",
        "openingHoursSpecification": [
          {
           "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
             "Monday",
             "Tuesday",
             "Wednesday",
             "Thursday",
             "Friday",
             "Saturday"
           ],
           "opens": "10:00",
           "closes": "19:00"
         }],
        "priceRange": "$$$",
	"address": {
		"@type": "PostalAddress",
		"streetAddress": "15011 8 Mile Rd",
		"addressLocality": "Eastpointe",
		"addressRegion": "MI",
		"postalCode": "48021",
		"addressCountry": "USA"
		},
	"location": {
		"@type": "Place",
		"geo": {
			"@type": "GeoCoordinates",
			"latitude": "42.45062",
			"longitude": "-82.96564"
			}
		},
	"areaServed": [{
		"@type": "City",
		"name": ["Eastpoite", "Roseville"]			
		}]
	}]
}` 
document.head.appendChild(el); 
}